module.exports = __webpack_public_path__ + "static/img/psd.a3189f92.png";